import type { ChatMedia } from "@stockline/shared/types/ai/chat-media"
import { CHAT_MEDIA_TABLE } from "../../../lib/offline/resources/ai/chat-media/db"
import { useAISync } from "../providers/AISyncProvider"

export function useChatMedia(sessionId: string | null): ChatMedia[] {
  const { reactive } = useAISync()
  const results = reactive.useQuery<ChatMedia>(
    CHAT_MEDIA_TABLE,
    sessionId ? { sessionId } : { sessionId: "__none__" }
  )
  return sessionId ? results : []
}

export function useChatMediaByMessage(messageId: string | null): ChatMedia[] {
  const { reactive } = useAISync()
  const results = reactive.useQuery<ChatMedia>(
    CHAT_MEDIA_TABLE,
    messageId ? { messageId } : { messageId: "__none__" }
  )
  return messageId ? results : []
}
